import React from 'react';

const ProcessSection = ({ data }) => {
  return (
    <section className="px-5 sm:px-6 py-14 md:py-20 bg-white">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-gray-900 text-center mb-10 md:mb-12">
          {data.title}
        </h2>
        
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {data.steps.map((step, index) => (
            <div key={index} className="text-center">
              <div className="w-14 h-14 bg-[#1a1f4e] text-white rounded-2xl flex items-center justify-center text-xl font-semibold mx-auto mb-5 shadow-[0_2px_8px_rgba(26,31,78,0.2)]">
                {step.number}
              </div>
              <h3 className="text-base sm:text-lg font-semibold text-gray-900 mb-2">
                {step.title}
              </h3>
              <p className="text-gray-600 text-sm sm:text-base leading-relaxed">
                {step.description}
              </p>
            </div>
          ))}
        </div>
        
        {/* Reassurance Line */}
        <p className="text-center text-gray-500 text-xs sm:text-sm">
          No contracts signed until scope and pricing are agreed.
        </p>
      </div>
    </section>
  );
};

export default ProcessSection;
